export default function initLoadImageGallery() {
    const toggle = document.getElementById('dropdownToggle');
      const menu = document.getElementById('dropdownMenu');
      const options = document.querySelectorAll('.dropdown-option');
      const selectedText = document.getElementById('selectedText');
      const requestedQuantity = document.getElementById('requestQuantity');

      toggle.addEventListener('click', () => {
        menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
      });

      options.forEach(option => {
        option.addEventListener('click', () => {
            selectedText.innerHTML = option.innerHTML;
            document.getElementById('selectedCustomerRef').innerText = option.getAttribute('data-cust-ref');
            document.getElementById('selectedPieceInOne').innerText = option.getAttribute('data-piece');
            document.getElementById('selectedShippingQty').innerText = option.getAttribute('data-ship-qty');
            document.getElementById('selectedNaed').innerText = option.getAttribute('data-naed');
            document.getElementById('selectedAvailability').innerText = option.getAttribute('data-available-qty');
            document.getElementById('unitPrice').innerText = option.getAttribute('data-currency') + option.getAttribute('data-unit-price');
            document.getElementById('totalAmount').innerText = option.getAttribute('data-unit-price');
            document.getElementById('packType').innerText = option.getAttribute('data-pack-type');
            document.getElementById('requestQuantity').setAttribute('data-unit-price',option.getAttribute('data-unit-price'));
            document.getElementById('requestQuantity').value = 1 ;
            menu.style.display = 'none';
        });
      });

      requestedQuantity.addEventListener('input', () => {
        const value = parseInt(requestedQuantity.value) || 0; // fallback to 0
        const unitPrice = requestedQuantity.getAttribute("data-unit-price");
        document.getElementById('totalAmount').innerText = (value * unitPrice).toFixed(2);

      });

      // Close dropdown when clicking outside
      window.addEventListener('click', (e) => {
        if (!document.getElementById('customDropdown').contains(e.target)) {
          menu.style.display = 'none';
        }
      });
}

